<template>
  <!-- 爱眼项目-项目组件 -->
  <div id="app-welfare">
    <div class="welfare-box">
      <div class="welfare-bottom">
        <div class="content-box" v-for="(item,index) in listData.data" :key="index">
          <router-link :to="{name:'projectDetails',query:{id:item.id,cid:cid,tabid:tabid}}">
            <div class="img-box">
              <img :src="item.paper_pic_url" alt>
            </div>
            <div class="con-box">
              <h3>{{item.project_name}}</h3>
              <p>{{item.project_summary}}</p>
              <!-- <ul>
                <li>
                  <h5>{{item.aims}}</h5>
                  <p>目标筹款/元</p>
                </li>
                <li>
                  <h5>{{item.current}}</h5>
                  <p>当前筹款/元</p>
                </li>
              </ul>-->
            </div>
          </router-link>
        </div>
      </div>
      <div class="page-box" v-if="listData.total > $db.config.projectListSize">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="listData.current_page"
          :page-size="$db.config.projectListSize"
          :total="listData.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["chid"],
  data() {
    return {
      classHide: false,
      classShow: true,
      cid:null,
      tabid:null,
      listData: []
    };
  },
  mounted() {
    this.cid = this.$route.query.cid
    this.tabid = this.$route.query.tabid
    
    // window.addEventListener("scroll", this.isElementInViewport, true);
    // console.log(321312,this.chid)
    this.getList(1);
  },
  watch: {
    chid: function(val) {
      this.getList(1);
    },
    '$route.query.tabid':function(value){
      if(value && value!=this.cid){
        this.tabid = value
      }
    }
  },
  methods: {
    getList(page) {
      this.$db
        .post(this.$db.config.getDataByChidUrl, {
          id: this.chid,
          page_size: this.$db.config.projectListSize,
          page: page
        })
        .then(res => {
          this.listData = res.data;
          // console.log(res)
        });
    },
    //改变页码
    handleCurrentChange(val) {
      this.getList(val);
    },

    // isElementInViewport() {
    //   let el = document.getElementById("app-welfare");
    //   let top = el.offsetTop;
    //   let lTop = document.documentElement.clientHeight;
    //   let b = top + 50 - lTop;
    //   // console.log(b);
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(b + "+++++" + scrollTop);
    //   if (scrollTop > b) {
    //     this.classHide = true;
    //   } else {
    //     this.classHide = false;
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
#app-welfare {
  width: 100%;
  margin-bottom: 45px;
}
.welfare-box {
  width: 1300px;
  margin: 0 auto;
  margin-top: 82px;
  .welfare-bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .content-box {
      width: calc(100% / 3);
      margin-bottom: 52px;
      cursor: pointer;
      transition: ease-out 0.6s;
      &:hover {
        // transform: scale(1, 1.05)
        box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
        .img-box {
          > img {
            transform: scale(1.05);
          }
        }
        > a {
          .con-box {
            background-color: #c30d23;
            transition: all 1.5s;
            > h3 {
              color: #fff;
            }
            > p {
              color: #fff;
            }
            > ul {
              > li {
                > h5 {
                  color: #fff;
                }
                > p {
                  color: #740f1b;
                }
              }
            }
          }
        }
      }
      > a {
        .img-box {
          width: 100%;
          height: 290px;
          overflow: hidden;
          > img {
            width: 100%;
            height: 100%;
            transition: all 1s;
          }
        }
        .con-box {
          height: 51px;
          padding: 28px 50px;
          > h3 {
            font-size: 18px;
            color: #333333;
            margin-bottom: 8px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > p {
            font-size: 14px;
            color: #999;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > ul {
            display: flex;
            margin-top: 30px;
            > li {
              width: 50%;
              list-style: none;
              > h5 {
                font-size: 18px;
                color: #333333;
                margin-bottom: 8px;
                overflow: hidden;
              }
              > p {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
  .page-box {
    text-align: center;
    margin-top: 20px;
  }
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #c30d23;
  color: #fff;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: solid 1px #dddddd;
  color: #999;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #c30d23;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_project.vue